import { ChangeEvent, useState } from "react";

function useInput(initialValue: string | number) {
  const [value, setValue] = useState<any>(initialValue);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return { value, onChange };
}

export default useInput;
